import { Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  padding: theme.spacing(1.5),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const RangeSlot = styled(Box)(({ theme }) => ({
  display: "flex",

  [theme.breakpoints.down("sm")]: {
    flexBasis: "100%",
  },
}));

export const Info = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1),
  marginLeft: "auto",

  [theme.breakpoints.down("sm")]: {
    marginLeft: 0,
  },
}));

export const SettingsSlot = styled(Box)(({ theme }) => ({
  display: "flex",

  [theme.breakpoints.down("sm")]: {
    marginLeft: "auto",
  },
}));

export const Dot = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: theme.palette.text.secondary,
}));
